/// <reference path='common.ts' />
/// <reference path='element_bind.ts' />

/**
 * 指定したURLのbodyタグ内のHTMLを当該エレメントの中に展開します。
 *
 * 属性
 * data-import: 読み込むURL
 * data-import-done: 処理した場合に付与される
 * data-import-cache: 取得した内容をセッションストレージに保存する場合
 *
 * イベント
 * fetch: 通信が完了した場合（detailはrequestとresponseのPromise）
 * fetch-error: 通信中にエラーが発生した場合（detailはrequestとエラー内容）
 * load: エレメントの中身を入れ替えた際に発生します
 */
class HaoriImport {
  /** セッションストレージのキーのプレフィックス */
  private static STORAGE_PREFIX = 'HaoriImport_';

  /** 画面のロードが完了するまでにインポートが完了したエレメントのリスト */
  static loadedElements: Array<Element> = [];

  /** 画面のロードが完了したらtrue */
  static isLoaded = false;

  /**
   * 対象エレメント内にHTMLを展開します。
   *
   * @param element 対象エレメント
   */
  static load(element: Element) {
    element.setAttribute('data-import-done', '');
    let url = <string>element.getAttribute('data-import');
    let useCache = element.hasAttribute('data-import-cache');
    if (!Haori.options.useStorageCache()) {
      useCache = false;
    }
    if (useCache) {
      let key = this.STORAGE_PREFIX + url;
      let html = sessionStorage.getItem(key);
      if (html != null) {
        element.innerHTML = html;
        if (this.isLoaded) {
          element.dispatchEvent(
            new Event('load', {
              bubbles: true,
              cancelable: true,
              composed: true,
            })
          );
        } else {
          this.loadedElements.push(element);
        }
        return;
      }
    }
    Haori.fetch([element], url, {}, (response, data) => {
      let document = new DOMParser().parseFromString(data, 'text/html');
      element.innerHTML = document.body.innerHTML;
      let key = this.STORAGE_PREFIX + url;
      if (useCache) {
        sessionStorage.setItem(key, document.body.innerHTML);
      } else {
        sessionStorage.removeItem(key);
      }
      if (this.isLoaded) {
        element.dispatchEvent(
          new Event('load', {
            bubbles: true,
            cancelable: true,
            composed: true,
          })
        );
      } else {
        this.loadedElements.push(element);
      }
    });
  }
}

document.body.addEventListener('change-bind', (event) => {
  (<HTMLElement>event.target).querySelectorAll('[data-import]:not([data-import-done])').forEach((element) => {
    HaoriImport.load(element);
  });
});

document.body.addEventListener('load', (event) => {
  (<HTMLElement>event.target).querySelectorAll('[data-import]:not([data-import-done])').forEach((element) => {
    HaoriImport.load(element);
  });
});

document.body.querySelectorAll('[data-import]:not([data-import-done])').forEach((element) => {
  HaoriImport.load(element);
});

window.addEventListener('load', () => {
  if (HaoriImport.isLoaded) {
    return;
  }
  HaoriImport.loadedElements.forEach((element) => {
    element.dispatchEvent(
      new Event('load', {
        bubbles: true,
        cancelable: true,
        composed: true,
      })
    );
  });
  HaoriImport.isLoaded = true;
});
